/**
 * Created by jonas on 2020-09-02.
 */
import {Logger, LogLevel, NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class SimpleObjectPool<T> {

    private _items:T[] = [];
    private _itemsInUse:T[] = [];
    private _itemsFree:T[] = [];


    private _growRate:number;
    private _maxSize:number;
    private _factory:() => T;
    public readonly name:string;
    private _logger:NamedLogger;
    private _logDeposit:boolean = false;
    private _logWithdraw:boolean = false;
    private _startSize:number;

    constructor(name:string, factory:()=>T, startSize:number, growRate:number = 1, maxSize?:number) {
        this.name = name;
        this._factory = factory;
        this._growRate = Math.max(Math.floor(growRate), 1);
        this._maxSize = maxSize ? maxSize : Number.MAX_VALUE;
        this._startSize = startSize;
        this.growPool(startSize);
    }

    private growPool(count:number) {
        if(this._items.length >= this._maxSize) {
            //debugger;
           // throw new Error(`Pool Exceeding max size (${this._maxSize}): ${this.toString()}` );
            Logger.warn(`Pool Exceeding max size (${this._maxSize}): ${this.toString()}`);
        }
        for(let i:number = 0; i < count; i++) {
            const newItem = this._factory();
            this._items.push(newItem);
            this._itemsFree.push(newItem);
        }

        this.log(`Growing pool with ${count} :`);
    }

    public setLogLevel(level:LogLevel, logDeposit:boolean = false, logWithdraw:boolean = false){
        if (!this._logger) {
            this._logger = Logger.createNamedLogger(this.name);
        }
        this._logDeposit = logDeposit;
        this._logWithdraw = logWithdraw;
        this._logger.level = level;
    }

    public withdraw():T{
        if(this._itemsFree.length == 0) {
            this.growPool(this._growRate);
        }
        const item = this._itemsFree.pop()!;
        this._itemsInUse.push(item);

        if (this._logWithdraw){
            this.log("Withdraw: ");
        }
        return item;
    }

    public deposit(item:T){
        const index = this._itemsInUse.indexOf(item);
        if (index >= 0){
            this._itemsFree.push(this._itemsInUse.splice(index,1)[0]);
        }

        if (this._logDeposit){
            this.log("Deposit: ");
        }
    }

    public toString(){
        return `${this.name}, Free : ${this._itemsFree.length}, In use: ${this._itemsInUse.length}, Total:${this._items.length}`;
    }

    private log(message:string){
        if (this._logger){
            this._logger.log(message + this.toString());
        }
    }

    public clean(removeFactor:number = 1) {
        const removeCount = Math.floor((this._itemsFree.length - this._startSize) * removeFactor);
        if (removeCount > 0){
            this._itemsFree.splice(-removeCount,removeCount);
            Logger.logDev(`Cleanup, deleted count:${removeCount} : ${this.toString()}`);
        }
    }
}